import { mockData } from "./Mock";
import { GetWithdrawsForMonthResponse, Withdraw } from "../../models/Commission";

const mockWithdraws: Withdraw[] = [
    {
        withdrawId: "W001",
        periodMonth: "2024-03",
        sellerId: "S001",
        sellerName: "张三",
        sellerPhone: "13800138001",
        currentAvailableIncome: 5000,
        withdrawAmount: 3000,
        taxAmount: 300,
        yearTotalWithdrawAmount: 15000,
        yearTotalTaxAmount: 1500,
        withdrawPostTime: new Date("2024-03-15 10:00:00"),
        status: 0
    },
    {
        withdrawId: "W002",
        periodMonth: "2024-03",
        sellerId: "S002",
        sellerName: "李四",
        sellerPhone: "13800138002",
        currentAvailableIncome: 8000,
        withdrawAmount: 5000,
        taxAmount: 500,
        yearTotalWithdrawAmount: 25000,
        yearTotalTaxAmount: 2500,
        withdrawPostTime: new Date("2024-03-16 14:30:00"),
        status: 1
    },
    {
        withdrawId: "W003",
        periodMonth: "2024-03",
        sellerId: "S003",
        sellerName: "王五",
        sellerPhone: "13800138003",
        currentAvailableIncome: 12000,
        withdrawAmount: 8000,
        taxAmount: 800,
        yearTotalWithdrawAmount: 30000,
        yearTotalTaxAmount: 3000,
        withdrawPostTime: new Date("2024-03-17 09:15:00"),
        status: 2
    },
    {
        withdrawId: "W004",
        periodMonth: "2024-03",
        sellerId: "S004",
        sellerName: "赵六",
        sellerPhone: "13800138004",
        currentAvailableIncome: 6000,
        withdrawAmount: 4000,
        taxAmount: 400,
        yearTotalWithdrawAmount: 18000,
        yearTotalTaxAmount: 1800,
        withdrawPostTime: new Date("2024-03-18 16:45:00"),
        status: 0
    },
    {
        withdrawId: "W005",
        periodMonth: "2024-03",
        sellerId: "S005",
        sellerName: "钱七",
        sellerPhone: "13800138005",
        currentAvailableIncome: 9000,
        withdrawAmount: 6000,
        taxAmount: 600,
        yearTotalWithdrawAmount: 22000,
        yearTotalTaxAmount: 2200,
        withdrawPostTime: new Date("2024-03-19 11:20:00"),
        status: 1
    }
];

const mockGetWithdrawsForMonthResponse: GetWithdrawsForMonthResponse = {
    totalAmount: 26000,
    totalCount: 5,
    paidAmount: 10000,
    paidCount: 3,
    withdraws: mockWithdraws
};

const mockCsvFileUrl = "https://example.com/commission/2024-03/withdraws.csv";

mockData.set("get_withdraws_for_month", mockGetWithdrawsForMonthResponse);
mockData.set("get_all_withdraws_csv_file_for_month", mockCsvFileUrl);
mockData.set("get_auto_withdraw_job_status", {
    month: "2026-03",
    executedThisMonth: false,
    running: false,
}); 